export const CALENDAR_GRID_WEEK_COLUMN_SKELETON_ROWS = [1, 3, 2, 4, 1, 3, 2]
